var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDugi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 58,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.186 31.28l-21.96 11.433 1.685 3.148 22.542-11.755c1.425-.77 2.008-2.569 1.231-3.982l-9.198-17.15-3.174 1.67 8.874 16.636z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.396 45.796L3.822 18.241 31.546 3.79l4.081 7.643 3.174-1.67-4.34-8.157c-.777-1.413-2.59-1.991-4.016-1.22L1.619 15.415c-1.425.77-2.008 2.569-1.23 3.982L15.545 47.98c.778 1.413 2.591 1.991 4.016 1.22l3.174-1.67-1.684-3.147-2.656 1.413z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.677 38.667L48.454 10.02c-.777-1.413-2.591-1.991-4.016-1.22l-3.174 1.67 1.684 3.147 2.591-1.349 14.575 27.49-27.66 14.452-4.016-7.643-3.174 1.67 4.34 8.221c.777 1.414 2.59 1.992 4.016 1.22L62.51 42.65c1.361-.77 1.944-2.57 1.167-3.982z",
    fill: "#0FAFE9",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.235 38.901h0l.004.007c.636 1.156.164 2.655-.967 3.302L33.389 57.235h0l-.007.004c-1.171.634-2.686.163-3.338-1.018l-4.104-7.775 2.288-1.203 3.783 7.2.232.442.442-.231 27.66-14.452.446-.233-.235-.445-14.575-27.49-.233-.439-.44.23-2.152 1.12-1.214-2.267 2.729-1.436h0l.005-.003c1.171-.633 2.686-.162 3.338 1.019l.002.003 15.22 28.64z",
    stroke: "#0FAFE9",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.952 16.828l-1.36-2.569-18.268 9.506c-1.166.642-1.62 2.056-1.036 3.212l7.45 14.002 2.59-1.349-7.19-13.488 17.814-9.314z",
    fill: "#0FAFE9",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.227 42.713l-3.239 1.67 1.684 3.212 3.24-1.67-1.685-3.212z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.312 14.645l3.174-1.67-1.684-3.212-3.174 1.67 1.684 3.212z",
    fill: "url(#paint3_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11.635,
    y1: 40.676,
    x2: 45.65,
    y2: 22.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FAFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#14B0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#23B2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#3BB6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#3FB7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 7.928,
    y1: 33.683,
    x2: 41.943,
    y2: 15.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FAFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#14B0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#23B2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#3BB6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#3FB7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 16.058,
    y1: 49.021,
    x2: 50.073,
    y2: 30.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FAFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#14B0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#23B2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#3BB6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#3FB7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 5.529,
    y1: 29.156,
    x2: 39.544,
    y2: 11.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C4394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#3C4898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#3D57A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#3D6FB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#3E90CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#3FB7E6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v58H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDugi);
export default __webpack_public_path__ + "static/media/dugi.eafaddbfedda6f05d41b34701a5472b7.svg";
export { ForwardRef as ReactComponent };